import { render, staticRenderFns } from "./newPayment.vue?vue&type=template&id=2bd345c6&"
import script from "./newPayment.vue?vue&type=script&lang=js&"
export * from "./newPayment.vue?vue&type=script&lang=js&"
import style0 from "./newPayment.vue?vue&type=style&index=0&id=2bd345c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports